export default "__VITE_ASSET__BQ4Koos9__"